exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".metric{margin:1em;padding:3em 3em 1em;background-color:#fff;text-align:center}.metric.first{margin-left:2em}.metric.last{margin-right:2em}.metric p.value{font-size:5em;font-weight:100;margin:0 0 40px}.metric p.label{font-size:1em;font-weight:100;color:#999;margin-bottom:0;text-align:left;line-height:40px}.metric .btn-create{background-color:#a3cc0e;border-color:#a3cc0e;color:#fff;font-size:.8em;margin-top:.5em}.metric .btn-create:hover{background-color:#93b80d;border-color:#93b80d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/dashboard/styles.styl
// module id = 947
// module chunks = 0